// API Configuration from environment variables
export const API_CONFIG = {
  HOST: process.env.REACT_APP_HOST || 'http://localhost',
  BACKEND_PORT: process.env.REACT_APP_BACKEND_PORT || '5000',
  JWT_EXPIRATION_TIME: process.env.REACT_APP_JWT_EXPIRATION_TIME || '24h',
};

// Production (Caddy): same host + /api
// Development: host:port from .env (backend should listen on 0.0.0.0)
const isProduction = process.env.NODE_ENV === 'production' || API_CONFIG.HOST.includes('https://');

export const API_BASE_URL = isProduction
  ? `${API_CONFIG.HOST}/api`
  : `${API_CONFIG.HOST}:${API_CONFIG.BACKEND_PORT}`;
